import { httpRequest } from "@services/http"
import { DropdownOption } from "@/modules/engagement/components/phases/scope/components/objectives/components/metrics/MetricItemDropdown"

export class CommandGetObjectiveListTypeChoices {
  async run(): Promise<DropdownOption[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/objectives/list-types/`
    return await httpRequest<DropdownOption[]>(url, { method: "GET" })
  }
}
